import { NgClass } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, output, input } from '@angular/core';
import { DxcButtonModule } from '@dxc-technology/halstack-angular';
import { ButtonProperties } from '@dxc-technology/halstack-angular/lib/dxc-button/dxc-button.types';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'custom-button',
  templateUrl: './custom-button.component.html',
  styleUrls: ['./custom-button.component.scss'],
  imports: [DxcButtonModule, NgClass, TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CustomButtonComponent {
  readonly id = input<string>(undefined);
  readonly className = input<string>(undefined);
  readonly widthFromParent = input<boolean>(false);

  /**Uses on of the available button modes. */
  readonly mode = input<ButtonProperties['mode']>('primary');

  /**Text to be placed inside the button. */
  readonly label = input<string>(undefined);

  /**URL of the icon that will be placed next to the button label. */
  // TODO: Skipped for migration because:
  //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
  //  and migrating would break narrowing currently.
  @Input() iconSrc: string = '';

  /**Whether the icon should appear after or before the label. */
  readonly iconPosition = input<ButtonProperties['iconPosition']>('before');

  /**If true, the component will be disabled. */
  readonly disabled = input<boolean>(false);

  /**Size of the margin to be applied to the component ('xxsmall' | 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge' | 'xxlarge'). You can pass an object with 'top', 'bottom', 'left' and 'right' properties in order to specify different margin sizes. */
  readonly margin = input<ButtonProperties['margin']>('medium');

  /**Size of the component ('small' | 'medium' | 'large' | 'fillParent' | 'fitContent'). */
  readonly size = input<ButtonProperties['size']>('fitContent');

  /**Value of the tabindex. */
  readonly tabIndexValue = input<number>(0);

  /**widthFromParent */
  readonly type = input<ButtonProperties['type']>('button');

  /**This function will be called when the user clicks the button. The event object will be passed as a parameter. */
  readonly onClick = output();
  readonly onMouseDown = output<MouseEvent>();

  onButtonClick() {
    this.onClick.emit();
  }

  mouseDown(event: MouseEvent) {
    if (this.disabled()) {
      event.preventDefault();
      return;
    }
    this.onMouseDown.emit(event);
  }
}
